import { useEffect, useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { useAuthStore } from '@/stores/authStore'
import { authApi } from '@/api/auth'
import { applyAuthenticated } from '@/lib/slackAuth'

export default function SlackCallback() {
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()
  const { setAuth } = useAuthStore()
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    const code = searchParams.get('code')
    const state = searchParams.get('state')
    const slackError = searchParams.get('error')

    if (slackError) {
      setError(slackError === 'access_denied' ? 'Access was denied' : `Slack error: ${slackError}`)
      return
    }

    if (!code || !state) {
      setError('Missing OAuth parameters')
      return
    }

    authApi.slackCallback(code, state)
      .then((result) => {
        if (result.status === 'select_org') {
          // Stash the picker payload and route to the org chooser.
          sessionStorage.setItem(
            'slack_org_select',
            JSON.stringify({
              selection_token: result.selection_token,
              organizations: result.organizations,
            }),
          )
          navigate('/select-org')
          return
        }
        applyAuthenticated(result, setAuth, navigate)
      })
      .catch((err) => {
        const detail = err?.response?.data?.detail || 'Slack sign-in failed'
        setError(detail)
      })
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
        <div className="max-w-md w-full space-y-4 text-center">
          <h1 className="text-xl font-bold text-gray-900">Sign-in Failed</h1>
          <p className="text-sm text-red-600">{error}</p>
          <a href="/login" className="inline-block text-sm text-brand hover:underline">
            Back to sign in
          </a>
        </div>
      </div>
    )
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <p className="text-gray-500">Signing in with Slack...</p>
    </div>
  )
}
